import React from "react";

export default class Footer extends React.Component {


  render() {
        return (
          <div className="fashufhasujf">  
        <div className="footer">
        Разработано компанией ОсОО © АВН
        </div>
        </div>
        )
    } 
}